import { useState } from 'react';
import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import RadioButtons from '../../../../components/Forms/RadioButtons';
import TextInput from '../../../../components/Forms/TextInput';
import Modal from '../../../modals/components/modal/Modal';
import { modalsActions } from '../../../modals/modalsSlice';
import useSubscription from '../../hooks/useSubscription';
import { askForSubscriptionUpdateThunk } from '../../services/subscriptionThunks';
import styles from './askForSubscriptionUpdateModal.module.scss';
import {
  subscriptionUpdateInitForm,
  subscriptionUpdateType,
} from './subscriptionModalConstants';

function AskForSubscriptionUpdateModal() {
  const { subscriptionIdIri } = useSubscription();
  const [input, setInput] = useState(subscriptionUpdateInitForm);

  const dispatch = useAppDispatch();

  const handleInputChange = (e: any) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log(e, input, subscriptionIdIri);
    if (input.title) {
      dispatch(
        askForSubscriptionUpdateThunk({
          ...input,
          subscriptionIdIri: subscriptionIdIri,
        }),
      );
    }
  };
  return (
    <Modal>
      <div className={styles.subscriptionUpdateModal}>
        <h2>Modification de l&apos;abonnement</h2>

        <form>
          <h3>Votre demande</h3>

          <RadioButtons
            name="title"
            style={{ justifyContent: 'flex-end' }}
            value={input.title}
            handleChange={handleInputChange}
            radioElts={subscriptionUpdateType}
          />
          <div className={styles.textAreaContainer}>
            <TextInput
              label="Commentaires"
              name="comment"
              value={input.comment}
              handleChange={handleInputChange}
              rows={4}
            />
          </div>
          <div className={styles.buttonGroup}>
            <Button
              btnType="button"
              btnContent="ANNULER"
              handleClick={() =>
                dispatch(modalsActions.askForSubscriptionUpdate(false))
              }
              textColor="violet"
              bgColor="grey"
              borderColor="grey"
            />
            <Button
              btnType="button"
              btnContent="VALIDER MA DEMANDE"
              handleClick={handleSubmit}
              primary
            />
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default AskForSubscriptionUpdateModal;
